import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelBanResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelBanCommand, se_DescribeChannelBanCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelBanCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannelBan", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelBanCommand")
    .f(void 0, DescribeChannelBanResponseFilterSensitiveLog)
    .ser(se_DescribeChannelBanCommand)
    .de(de_DescribeChannelBanCommand)
    .build() {
}
